import React from 'react';

interface StatusTileProps {
  title: string;
  count: number;
  icon: React.ReactNode;
  bgColor: string;
  borderColor:string
  textColor: string;
  onClick?: () => void;
  isActive?: boolean;
}

const StatusTile: React.FC<StatusTileProps> = ({ 
  title, 
  count, 
  icon, 
  bgColor, 
  borderColor,
  textColor, 
  onClick,
  isActive 
}) => {
  return (
    <div
  onClick={onClick}
  className={`relative overflow-hidden rounded-xl shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer transform hover:scale-105 border-l-4 border-opacity-100 ${
    isActive 
      ? 'ring-1 ring-blue-500 ring-opacity-50 border-l-blue-500 shadow-blue-200/50' 
      : `${borderColor} `
  }`}
  role={onClick ? "button" : undefined}
  tabIndex={onClick ? 0 : undefined}
>
  <div className={`${bgColor} px-2 xl:pl-4 xl:pr-6 py-2 ltr:rounded-r-2xl rtl:rounded-l-2xl`}>
    <div className="flex items-center justify-between">
      <div>
        <p className={` text-sm xl:text-sm font-medium ${textColor} opacity-90 mb-1 leading-tight`}>{title}</p>
        <p className={`text-lg xl:text-lg font-bold ${textColor} leading-none`}>{count.toLocaleString()}</p>
      </div>
      <div className={`${textColor} opacity-70 transform  flex-shrink-0`}>
        {icon}
      </div>
    </div>
  </div>
</div>

  );
};

export default StatusTile;
export type { StatusTileProps };
